import { createUseTranslation } from "core/session/translation";

export const dialogTranslation = {
  en: {
    moveTooltip: "Hold to Move the Dialog",
  },
};

export const useDialogTranslation = createUseTranslation(dialogTranslation);
